import React from "react";
import { CloseIcon } from "@icarius-icons";
import { Dialog, DialogTitle, DialogContent, Grid, DialogActions } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import PaperDraggable from "@icarius-common/paperDraggable";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import DialogTransition from "@icarius-common/dialogTransition";
import SelectedUsersColumn from "@icarius-common/userSelectionDialog/selectedUsersColumn";
import UserSelectionColumn from "@icarius-common/userSelectionDialog/userSelectionColumn";
import useHandleUserSelection from "@icarius-common/userSelectionDialog/useHandleUserSelection";

const UserSelectionDialogWithReplica = (props) => {

  const {
    open,
    people, //array de objetos con key, name y FOTOGRAFIA
    handleClose,
    handleSubmit,
  } = props;

  const {
    keysSelected,
    checkedList,
    handleSelection,
  } = useHandleUserSelection(people, [], true);

  const handleSubmitUsers = () => {
    handleSubmit(people?.find(el => el.key === keysSelected[0]));
    handleClose();
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"md"}
      fullWidth
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        {getLocalizedString("searchEmployee")}
        <DialogTitleDivider />
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogContent>
        <Grid container direction="row" justify="space-around">
          <SelectedUsersColumn
            employees={checkedList}
            title={getLocalizedString("selectedEmployee")}
            showAmount={false}
            handleClick={handleSelection}
          />
          <UserSelectionColumn
            employees={checkedList}
            filterPlaceholder={getLocalizedString("searchEmployee")}
            handleClick={handleSelection}
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <ButtonDialogAction onClick={handleClose} text={getLocalizedString("disagree")} />
        <ButtonDialogAction disabled={keysSelected.length === 0} onClick={() => handleSubmitUsers(false)} isAccept text={getLocalizedString("search")} />
      </DialogActions>
    </Dialog>
  );
}

export default UserSelectionDialogWithReplica;